import { FeatureFlagConfig, FeatureFlagsEnum } from "configs/types";

// Optimizely remote feature-flag SDK removed in modernization.
// Flags are seeded from local defaults into localStorage only.
class FeatureFlag {
  static isInitialized = false;
  static initialize(featureFlagConfig?: FeatureFlagConfig) {
    if (featureFlagConfig) {
      Object.keys(featureFlagConfig.default).forEach((flag: any) => {
        // This is required because otherwise it will reset the values
        // every time the application is loaded.
        if (localStorage.getItem(flag) === null) {
          localStorage.setItem(
            flag,
            featureFlagConfig.default[flag as FeatureFlagsEnum].toString(),
          );
        }
      });
    }
    FeatureFlag.isInitialized = true;
  }

  static identify(_userData: any) {
    // No remote provider; local defaults already seeded in initialize().
  }

  static check(flagName: string) {
    return localStorage.getItem(flagName) === "true";
  }
}

export default FeatureFlag;
